import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import flatten from 'lodash/flatten';
import { DatePicker } from '@material-ui/pickers';
import { NotificationManager } from 'react-notifications';
import LoggedInContainer from '../../components/loggedInContainer/loggedInContainer';
import OrdersList from '../../components/ordersList/ordersList';
import http from '../../services/http';

import './ordersList.less';

class OrdersListPage extends React.Component {
  constructor(props) {
    super(props);

    const selectedMonth = moment();

    this.state = {
      orders: [],
      selectedMonth,
    };

    this.fetchOrders(selectedMonth);
  }

  fetchOrders = async monthDate => {
    const now = monthDate;
    const allDaysInMonth = now.daysInMonth();

    const calls = [];

    for (let i = 0; i < allDaysInMonth; i += 1) {
      const dayOfMonth = i + 1;
      const date = moment(now.date(dayOfMonth));

      calls.push(this.fetchOrdersForDay(date));
    }

    const orders = flatten(await Promise.all(calls));
    this.setState({ orders });
  }

  fetchOrdersForDay = async date => {
    const { realized } = this.props;
    const status = realized ? 2 : 1;

    const { items } = await http.post('/api/admin/getorders', {
      OrderDate: moment(date).format('DD-MM-YYYY'),
      Page: {
        PageIndex: 0,
        PageSize: 1000,
      },
      Status: status,
    });

    return items;
  }

  chooseMonth = selectedMonth => {
    this.setState({ selectedMonth });
    this.fetchOrders(selectedMonth);
  }

  changeOrderStatus = async (id, status) => {
    const { selectedMonth } = this.state;
    try {
      await http.post('/api/admin/amendorderstatus', {
        OrderId: id,
        Status: status,
      });
    } catch {
      NotificationManager.error('Nie udało się zmienić statusu zamówienia.', 'Błąd', 5000);
      return;
    }

    await this.fetchOrders(selectedMonth);
    NotificationManager.success('Zmieniono status zamówienia.', 'Sukces', 5000);
  }

  deleteOrder = async id => {
    const { selectedMonth } = this.state;
    try {
      await http.delete('/api/admin/deleteorder', {
        Id: id,
      });
    } catch {
      NotificationManager.error('Nie udało się usunąć zamówienia.', 'Błąd', 5000);
      return;
    }

    await this.fetchOrders(selectedMonth);
    NotificationManager.success('Usunięto zamówienie.', 'Sukces', 5000);
  }

  render() {
    const { orders, selectedMonth } = this.state;

    return (
      <LoggedInContainer>
        <div className="page-title">
          <Typography variant="h5">
            Lista zamówień
          </Typography>
        </div>

        <div className="orders-list-page__selected-month-wrapper">
          <DatePicker
            views={['year', 'month']}
            label="Wybierz miesiąc i rok"
            helperText="Kliknij, by filtrować zamówienia wg. miesiąca"
            value={selectedMonth}
            onChange={this.chooseMonth}
          />
        </div>
        <OrdersList
          orders={orders}
          changeOrderStatus={this.changeOrderStatus}
          deleteOrder={this.deleteOrder}
        />
      </LoggedInContainer>
    );
  }
}

OrdersListPage.propTypes = {
  realized: PropTypes.bool.isRequired,
};

export default OrdersListPage;
